import React from "react";
import DepartmentHome from "../components/DepartmentHome.jsx";

const items = [
  ["CRM & Referrals", "/admin/crm", "Track referral sources and new client leads"],
  ["Executive BI", "/admin/executive", "High-level business performance metrics"],
];

const icons = {
  "CRM & Referrals": "🤝",
  "Executive BI": "📈",
};

export default function GrowthHome() {
  return (
    <DepartmentHome
      title="Growth & Intelligence"
      description="Referral pipeline, CRM, and executive business intelligence."
      items={items}
      icons={icons}
    />
  );
}
